export default __webpack_public_path__ + "static/media/jfin.82d80a0d.jpg";